import React, { Component } from 'react';
import { Field } from 'react-form';
import { validate } from '../../utils/validation';
import { connect } from 'react-redux';



class TextFields extends Component {
    state = {value: ''};

    componentDidMount(){
        if (this.props.defaultValue && this.props.formApi) {
            this.props.formApi.setValue(this.props.field, this.props.defaultValue);
            this.setState({value: this.props.defaultValue});
        }
    }

    render() {
        let styles = {};

        if (this.props.arb) {
            styles.direction = 'rtl'
        }

        if (this.props.hide) {
            styles.display = 'none'
        }
        return (
            <Field validate={ value => validate(value, this.props.validations) } field={ this.props.field } >
                { fieldApi => {
                    const { setValue } = fieldApi;

                    return (
                        <textarea placeholder="Add description here"
                                  className={this.props.tab ? 'with-tab' : ''}
                                  style={styles}
                                  onChange={e => {setValue(e.target.value); this.setState({value: e.target.value})} }
                                  value={this.state.value}/>
                    );
                }}
            </Field>
        );
    }
}

const mapStateToProps = state => {
    return {
        error: state.auth.error
    }
};


export default connect(mapStateToProps)( TextFields );


// WEBPACK FOOTER //
// ./src/components/UI/Textarea.js